import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  HostBinding,
  HostListener,
  AfterViewInit,
  Compiler,
  ChangeDetectionStrategy
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { navList } from '../nav-data';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSidenav } from '@angular/material/sidenav';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import _ from 'lodash';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationCancel,
  RouterModule,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IncomeCallService } from '../../../_Common/_Services/income-call.service';
import { PushNotificationsService } from '../../../_Common/_Services/push-notification.service';
import { UserService } from '../../../_Common/_Services/user.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MFieldsService } from '../../../components/mobile-components/mobile-timeline/m-fields/m-fields.service';
import { DexieService } from '../../../services/dexie/dexie.service';
import { MPaymentService } from '../../../components/mobile-components/mobile-timeline/m-payments/m-payment.service';
import { paymentArrayJson } from '../../../_Common/_Models/customerReponsePaymentArray';
import { MPhoneService } from '../../../components/mobile-components/mobile-timeline/m-phone/m-phone.service';
import { loadingSteps } from '../../../_Common/_Models/loading-steps';
import { MatDialog } from '@angular/material/dialog';
import { RouterLink, RouterOutlet } from '@angular/router';
import { SharedModule } from '../../../_Common/_Components/shared.module';
import { AngularMaterialModule } from '../../../_Common/_Modules/angular.material.module';
import { PaymentNotificationsComponent } from '../../timeline4/payment-notifications/payment-notifications.component';
import { CallingModule } from 'src/app/components/calling/calling.module';
import { OzonetelService } from 'src/app/components/calling/ozonetel/ozonetel.service';
import { OzonetelSDKService } from 'src/app/components/calling/ozonetel/ozonetel-sdk.service';
import { OzonetelSDKCoreService } from 'src/app/components/calling/ozonetel/ozonetel-sdk-core.service';
import { OzonetelIframeComponent } from 'src/app/components/ozonetel-iframe/ozonetel-iframe.component';
import { HttpClient } from '@angular/common/http';
import {
  getOzonetelDialerMode,
  isOzonetelIframeDialer,
  isOzonetelSdkDialer,
} from 'src/app/components/calling/ozonetel/ozonetel-dialer-mode';
import { OzonetelDialerFlowService } from 'src/app/components/calling/ozonetel/ozonetel-dialer-flow.service';
import {
  CallingDialerType,
  resolveCallingDialerType,
  shouldShowCallingWidget,
  shouldShowCubeIframe,
  shouldShowOzonetelIframe,
  toWidgetCallingType,
} from 'src/app/components/calling/calling-dialer-mode';
import { CubeDialerFlowService } from 'src/app/components/calling/cube/cube-dialer-flow.service';
import { CentroDialerFlowService } from 'src/app/components/calling/centro/centro-dialer-flow.service';
import { CubeConnectorCoreService } from 'src/app/components/calling/cube/cube-connector-core.service';
import { isCubeWebphoneConnector } from 'src/app/components/calling/cube/cube-dialer-mode';
import { CallingService } from 'src/app/components/calling/calling.service';
import { CentroSipService } from 'src/app/components/calling/centro/centro-sip.service';
import { CentroControlWsService } from 'src/app/components/calling/centro/centro-control-ws.service';

export const MY_FORMATS = {
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
    selector: 'mt-sidenav',
    templateUrl: 'sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    imports: [
        RouterLink,
        RouterOutlet,
        CallingModule,
        AngularMaterialModule,
        SharedModule,
        RouterModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        IncomeCallService,
        DexieService,
        MFieldsService,
        MPaymentService,
        MPhoneService,
        UserService,
    ]
})
export class SidenavComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('snav') drawer: MatSidenav;
  @ViewChild(OzonetelIframeComponent) ozonetelIframe: OzonetelIframeComponent;
  private subscriptions = new Subscription();
  mobileQuery: MediaQueryList;
  mobileQueryListener: () => void;
  navItems: any = [];
  imgSrc: string;

  getState: Observable<any>;
  isAuthenticated: false;
  user = null;
  errorMessage = null;
  instituteImgUrl: any;
  instituteName: any;
  loggedInUser: string;
  userRemarks: string;
  ioConnection: any;
  callDefDetails: any;
  instructOrEscalateObject: any;
  agentID: any;
  // STEP 7 (dedupe): CallSids already used to open an IVR timeline this session — avoids double windows.
  private openedIvrCallSids = new Set<string>();
  agencyId: string = null;
  loggedInUserEmail: string = null;
  userId: string = null;
  instituteID: any;
  instituteCode: any;
  progressiveCallObj: any = {};
  timeValidity = 300000; // 5 minutes;
  loading: boolean;
  btnName = 'Change Language';
  languages: any = [
    { name: 'English', unicode: 'en' },
    { name: 'हिंदी', unicode: 'hn' },
    { name: 'मराठी', unicode: 'mr' },
    { name: 'தமிழ்', unicode: 'tm' },
    { name: 'తెలుగు', unicode: 'tl' },
    { name: 'ಕನ್ನಡ', unicode: 'kn' },
  ];
  paymentNotificationsArray: any = [];
  notifyCount: number = 0;

  @HostBinding('class') componentCssClass;
  isDark: boolean = false;
  isFieldAgent: boolean = false;
  isTelecaller: boolean = false;
  // for home screen button
  deferredPrompt: any;
  showButton = false;
  installbuttons: any = [
    { label: 'Cancel', class: 'nobg error', submit: false },
    { label: 'Install', class: '', submit: true },
  ];
  logOutButtons: any = [
    { label: 'Cancel', class: 'nobg error', submit: false },
    { label: 'Logout', class: 'error', submit: true },
  ];
  locationModalButtons: any = [
    { label: 'No', class: 'nobg error', submit: false },
    { label: 'Yes', class: 'success', submit: true },
  ];
  syncManagerButtons: any = [
    { label: 'Cancel', class: 'nobg error', submit: false },
    { label: 'Sync now', class: 'success', disabled: true, submit: true },
  ];
  showSyncModal: boolean = false;
  logoutModal: boolean;
  // Skip the close-tab prompt for F5 / Ctrl+R / app-triggered reload. Close tab still prompts.
  allowReload = false;
  contentbody: boolean;
  addToHomeModal: boolean;
  locationPermission: boolean = false;
  responsesArray: any = [];
  syncingNowMsg: string = null;
  loadingSteps: any = [];
  showDialler: boolean = true;
  ozonetelDialerMode = getOzonetelDialerMode();
  useOzonetelSdkDialer = isOzonetelSdkDialer();
  useOzonetelIframeDialer = isOzonetelIframeDialer();
  showOzonetelIframe: boolean = this.useOzonetelIframeDialer;
  showCallingWidget = false;
  showOzonetelIframeDialer = false;
  showCubeIframeDialer = false;
  activeDialerType: CallingDialerType = 'none';

  // tslint:disable
  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.addToHomeScreen();
  }

  /*
    Logged-in users must logout before closing the tab.
    Chrome will not show a custom message on its Leave site? dialog, so we show a snackbar.
    The dialog also blocks painting, so the snackbar is opened when the mouse leaves toward
    the tab bar (before the native dialog). Chrome consumes the prompt after Leave/Cancel;
    the next click re-binds beforeunload so the prompt can show again. After a full reload
    the user must click the page once, then close, or Chrome will not show the dialog.
  */
  @HostListener('window:keydown', ['$event'])
  onWindowKeydown(event: KeyboardEvent) {
    if (event.key === 'F5' || ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'r')) {
      this.allowReload = true;
    }
  }

  // @HostListener('document:mouseleave', ['$event'])
  // onDocumentMouseLeave(event: MouseEvent) {
  //   if (this.userService.isLoggedIn() && event.clientY <= 0) {
  //     this.snackbar.open('please logout before closing the tab', 'Okay', { duration: 5000 });
  //   }
  // }

  @HostListener('document:click')
  onDocumentClick() {
    if (!this.userService.isLoggedIn()) {
      return;
    }
    this.allowReload = false;
    window.onbeforeunload = (event: BeforeUnloadEvent) => this.onBeforeUnload(event);
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    if (!this.userService.isLoggedIn() || this.allowReload) {
      return;
    }
    this.snackbar.open('please logout before closing the tab', 'Okay', { duration: 5000 });
    event.preventDefault();
    event.returnValue = 'please logout before closing the tab';
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService,
    private media: MediaMatcher,
    private router: Router,
    private socketService: IncomeCallService,
    private notificationService: PushNotificationsService,
    private snackbar: MatSnackBar,
    public overlayContainer: OverlayContainer,
    private translateService: TranslateService,
    private mFieldService: MFieldsService,
    private mPhoneService: MPhoneService,
    private mPayService: MPaymentService,
    private dexieService: DexieService,
    private dialog: MatDialog,
    private ozonetelService: OzonetelService,
    private ozonetelSDKService: OzonetelSDKService,
    private ozonetelSDKCore: OzonetelSDKCoreService,
    private http: HttpClient,
    private ozonetelDialerFlow: OzonetelDialerFlowService,
    private cubeDialerFlow: CubeDialerFlowService,
    private centroDialerFlow: CentroDialerFlowService,
    private cubeConnector: CubeConnectorCoreService,
    private callingService: CallingService,
    private centroSip: CentroSipService,
    private centroControlWs: CentroControlWsService
  ) {
    this.imgSrc = '../../../favicon.ico';
    this.mobileQuery = this.media.matchMedia('(max-width: 768px)');
    this.mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.instituteID = this.userService.getInstituteId();
    try {
      const language = localStorage.getItem('language');
      if (language) {
        this.translateService.use(language);
      } else {
        this.translateService.use('en');
      }
    } catch (e) { }
  }

  clearCache() {
    this.userService.clearCache();
    this.allowReload = true; // in-app reload should not ask to logout
    location.reload();
  }

  ngOnInit() {
    const isDark = JSON.parse(localStorage.getItem('isDarkMode'));
    this.onSetTheme({ checked: isDark });
    this.agencyId = this.userService.getLoggedInOrganizationId();
    this.loggedInUserEmail = this.userService.getLoggedInUserEmail();
    this.userRemarks = localStorage.getItem('remarks');
    this.loggedInUser = this.userService.getFirstName();
    this.userService.getDbName().subscribe((institutes: any[]) => {
      const match = institutes.find(i => String(i.id) === String(this.instituteID));
      if (match) this.instituteImgUrl = match.imageUrl;
    });
    this.instituteName = localStorage.getItem('instituteName');
    this.userId = this.userService.getLoggedInUserId();
    this.socketService.uniqueUserId = this.userId + '' + this.instituteID;
    // this.socketService.uniqueUserId = this.loggedInUserEmail;
    this.getNavItems();
    this.getInstituteCode();
    if (this.userService.checkFieldAgentOnMobile()) this.isFieldAgent = true;
    else this.isFieldAgent = false;
    if (this.userService.checkIsTelecallerOnMobile()) this.isTelecaller = true;
    else this.isTelecaller = false;
    let parsedRemarks: any = null;
    if (this.userRemarks) {
      try {
        const remarks = JSON.parse(this.userRemarks);
        parsedRemarks = remarks;
        if (remarks.agentID != null) {
          this.agentID = remarks.agentID;
        } else if (remarks.exotelAgentID != null) {
          this.agentID = remarks.exotelAgentID;
        } else if (remarks.ozonetelDetails?.agentId != null) {
          this.agentID = remarks.ozonetelDetails.agentId;
        }
      } catch (err) { }
    }
    if (!this.agentID) {
      this.agentID = localStorage.getItem('userAgentId') || null;
    }
    this.initIoConnection();
    const callingServcies = this.userService.getCallingService();
    this.activeDialerType = resolveCallingDialerType(callingServcies, parsedRemarks);
    const widgetCallingType = toWidgetCallingType(this.activeDialerType);

    console.log('[Sidenav] Calling Service:', callingServcies, 'Active dialer:', this.activeDialerType, 'Ozonetel mode:', this.ozonetelDialerMode);

    if (this.activeDialerType === 'cube' || this.activeDialerType === 'ozonetel' || this.activeDialerType === 'centro') {
      this.showDialler = true;
      this.progressiveCallObj = {
        ...this.progressiveCallObj,
        callingType: widgetCallingType,
        Status: this.progressiveCallObj?.Status || 'Idle',
        pauseCall: false,
        holdCall: false,
      };
    }

    if (this.activeDialerType === 'cube' && isCubeWebphoneConnector()) {
      this.subscriptions.add(
        this.cubeConnector.callState$.subscribe((state) => {
          if (!state) {
            return;
          }
          if (state.callDirection === 'campaign' && state.Status === 'CALLING' && !state.customerAnswered) {
            return;
          }
          this.progressiveCallObj = {
            ...this.progressiveCallObj,
            ...state,
            callingType: 'cube',
          };
          this.socketService.setCallingRes(this.progressiveCallObj);
          this.changeDetectorRef.markForCheck();
        })
      );
    }

    this.showCallingWidget = shouldShowCallingWidget(widgetCallingType);
    this.showOzonetelIframeDialer = shouldShowOzonetelIframe(widgetCallingType);
    this.showCubeIframeDialer = shouldShowCubeIframe(widgetCallingType);
    this.showOzonetelIframe = this.showOzonetelIframeDialer;
    this.initiatecalling();
    if (
      localStorage.getItem('paymentNotifications') &&
      JSON.parse(localStorage.getItem('paymentNotifications')).length > 0
    ) {
      this.notifyCount = JSON.parse(
        localStorage.getItem('paymentNotifications')
      )[0].count;
    }
    if (
      this.userService.checkFieldAgentOnMobile() &&
      !this.userService.getUserLocation()
    ) {
      this.locationPermission = true;
    }
    if (this.userService.checkFieldAgentOnMobile()) {
      this.showDialler = false;
    }
    // else this.showDialler = true;
  }

  // to ask for the user's @location
  getCurrentLocation() {
    this.userService
      .getCurrentGeolocation()
      .then((geolocation: any) => { })
      .catch((err: any) => {
        this.locationPermission = true;
      });
  }
  getInstituteCode() {
    if (this.instituteID == '65') {
      this.instituteCode = 'P1';
    } else if (this.instituteID == '64') {
      this.instituteCode = 'P2';
    } else if (this.instituteID == '66') {
      this.instituteCode = 'P3';
    } else if (this.instituteID == '67') {
      this.instituteCode = 'P4';
    } else if (this.instituteID == '68') {
      this.instituteCode = 'P5';
    } else if (this.instituteID == '13') {
      this.instituteCode = 'P6';
    } else if (this.instituteID == '69') {
      this.instituteCode = 'P7';
    } else if (this.instituteID == '70') {
      this.instituteCode = 'P8';
    } else if (this.instituteID == '71') {
      this.instituteCode = 'P2-D';
    } else if (this.instituteID == '72') {
      this.instituteCode = 'P4-D';
    } else if (this.instituteID == '74') {
      this.instituteCode = 'P12';
    }
  }

  // on deny the location permission
  onLocationPermission(event$: boolean) {
    if (event$) {
      this.locationPermission = false;
      this.getCurrentLocation();
      return;
    }
    this.allowReload = true; // in-app reload should not ask to logout
    location.reload();
    this.logout();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.socketService.closeSockets();
    this.mobileQuery.removeListener(this.mobileQueryListener);
    window.onbeforeunload = null; // drop the close-tab guard when sidenav is destroyed (logout)
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }

  addToHomeScreen() {
    // hide our user interface that shows our Add to Home Screen button
    this.showButton = false;
    // Show the prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt

    this.deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        // TODO: here we can count the number of users who created/installed app
        this.snackbar.open('The Moneytor App will install shortly', 'Okay', {
          duration: 3000,
        });
      } else {
      }
      this.deferredPrompt = null;
    });
  }

  onLogoutActions($event: boolean) {
    if ($event) {
      this.logout();
      return;
    }
    this.logoutModal = false;
  }

  // not in use for now
  onAppInit($event: boolean) {
    let accepted = $event;

    if ($event) {
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (accepted) {
          // TODO: here we can count the number of users who created/installed app or shortcut
          this.snackbar.open('The Moneytor App will install shortly', 'Okay', {
            duration: 3000,
          });
        } else {
        }
        this.deferredPrompt = null;
      });
      this.addToHomeModal = false;
      return;
    }
    this.addToHomeModal = false;
  }

  // to set theme
  onSetTheme($event: any) {
    const { checked } = $event;
    const theme = checked ? 'dark-theme' : 'light-theme';
    this.overlayContainer.getContainerElement().classList.add(theme);
    this.componentCssClass = theme;
    this.isDark = checked;
    localStorage.setItem('isDarkMode', JSON.stringify(checked));
  }

  // set id for agent and agency
  getNavItems() {
    this.navItems = JSON.parse(JSON.stringify(navList));
    this.navItems.map((nav: any) => {
      if (nav.key === 'profile') nav.path += this.userId;
      if (nav.key === 'agency') nav.path += this.agencyId;
    });
  }

  // to show the navItems as per the userRoles
  shouldShow($event: any) {
    let tobeShow: boolean = false;
    $event.some((show: any) => {
      if (show.includes(['all'])) {
        tobeShow = true;
      } else {
        if (this.userService.userHasRole(show)) {
          tobeShow = true;
        }
      }
      // disabled for now we are not showing them to field and telecaller
      // if (show.includes(['isNotFieldAgent'])) {
      //   tobeShow = this.isFieldAgent;
      // } else if (show.includes(['isNotTelecaller'])) {
      //   tobeShow = this.isTelecaller;
      // }
    });
    return tobeShow;
  }

  // to close side nave on mobile
  navigateTo(nav: any) {
    window.scroll(0, 0);
    if (this.mobileQuery.matches) this.drawer.close();
  }

  // to logout the user
  private async logoutOzonetelSdkIfActive() {
    if (!this.useOzonetelSdkDialer) {
      return;
    }
    if (!this.ozonetelSDKCore.isAgentInitialized()) {
      return;
    }
    try {
      const config = await this.ozonetelSDKCore.getAgentConfigFromDB();
      const details = config?.ozonetelDetails || {};
      const customer = details.customer || details.userName;
      const agentId = details.agentId;
      if (!customer || !agentId) {
        return;
      }
      await this.ozonetelSDKCore.logoutAgent(customer, agentId);
    } catch (error) {
      console.error('[Sidenav] Ozonetel SDK logout failed', error);
    }
  }

  logout() {
    if (isCubeWebphoneConnector()) {
      this.cubeConnector.teardownForUnload();
    }
    if (this.activeDialerType === 'centro') {
      this.centroSip.teardown();
      this.centroControlWs.disconnect();
      this.callingService.logoutCentroAgent().subscribe({ error: () => {} });
    }

    this.userService.logoutUser().subscribe(async (res) => {
      console.log('Error', res);
      await this.logoutOzonetelSdkIfActive();

      if (this.ozonetelIframe) {
        this.ozonetelIframe.clearIframe();
      }

      this.userService.clearCache();
      this.userService.logout();
      this.logoutModal = false;
      if (res.resultShort === 'failure') {
        this.snackbar.open(res.resultLong, 'Done', {
          duration: 4000,
        });
      }
    });
  }

  // to change the language
  changeLanguage(lang: string) {
    this.translateService.use(lang);
    localStorage.setItem('language', lang);
  }

  // on progressive dialler start
  async initializeOzonetelSDK() {
    try {
      console.log('=== Starting Ozonetel SDK Initialization ===');
      const userRemarks = localStorage.getItem('remarks');
      console.log('User remarks from localStorage:', userRemarks);

      if (!userRemarks) {
        console.error('No remarks found in localStorage. Please logout and login again.');
        this.snackbar.open('Please logout and login again to initialize Ozonetel', 'Warning', {
          duration: 5000
        });
        return;
      }

      const remarks = JSON.parse(userRemarks);
      console.log('Parsed remarks:', remarks);

      let ozonetelDetails = remarks.ozonetelDetails;

      if (!ozonetelDetails || !ozonetelDetails.customer || !ozonetelDetails.agentId) {
        console.log('Ozonetel details not in remarks, fetching from server...');

        try {
          const response: any = await this.http.get('/api/user/profile').toPromise();
          console.log('User profile response:', response);

          if (response && response.user && response.user.fieldJSON1) {
            ozonetelDetails = response.user.fieldJSON1.ozonetelDetails;
            console.log('Ozonetel details from server:', ozonetelDetails);
          }
        } catch (error) {
          console.error('Failed to fetch user profile:', error);
        }
      }

      if (!ozonetelDetails) {
        console.error('No ozonetelDetails found. Please contact admin.');
        this.snackbar.open('Ozonetel credentials not configured. Please contact admin.', 'Warning', {
          duration: 5000
        });
        return;
      }

      const config = {
        customer: ozonetelDetails.customer || ozonetelDetails.userName,
        agentId: ozonetelDetails.agentId,
        phoneNumber: ozonetelDetails.phoneNumber || '',
        pin: ozonetelDetails.pin || '',
        sip: ozonetelDetails.sip !== false,
        userName: ozonetelDetails.userName,
        campaignName: ozonetelDetails.campaignName
      };

      console.log('Initializing Ozonetel SDK with config:', {
        ...config,
        pin: '***'
      });

      const result = await this.ozonetelSDKService.initializeAgent(config);
      console.log('Ozonetel SDK initialized successfully:', result);

      this.snackbar.open('Ozonetel SDK Ready - Agent Logged In', 'Success', {
        duration: 3000
      });

      await this.ozonetelSDKService.setAgentMode('INBOUND', 'IDLE');
      console.log('Agent mode set to INBOUND');

      this.snackbar.open('Ready for Inbound Calls', 'Success', {
        duration: 2000
      });

    } catch (error) {
      console.error('Error initializing Ozonetel SDK:', error);
      this.snackbar.open('Error initializing Ozonetel: ' + (error.message || error), 'Error', {
        duration: 5000
      });
    }
  }

  setupOzonetelEventListeners() {
    window.addEventListener('ozonetel-call-started', (event: any) => {
      console.log('Ozonetel call started event:', event);
      this.progressiveCallObj = {
        ...this.progressiveCallObj,
        Status: 'Connected',
        callingType: 'ozonetel'
      };
    });

    window.addEventListener('ozonetel-call-ended', (event: any) => {
      console.log('Ozonetel call ended event:', event);
      this.progressiveCallObj = {
        ...this.progressiveCallObj,
        Status: 'Disconnected',
        callingType: 'ozonetel'
      };

      setTimeout(() => {
        this.progressiveCallObj = {
          ...this.progressiveCallObj,
          Status: 'Idle'
        };
      }, 2000);
    });

    window.addEventListener('ozonetel-additional-text', (event: any) => {
      console.log('Ozonetel additional text:', event);
    });

    window.addEventListener('ozonetel-user-speaking', (event: any) => {
      console.log('Ozonetel user speaking:', event);
    });
  }

  setAgentReady() {
    console.log('Setting agent to Ready status...');
    this.http.post('/api/callManager/setAgentReady', {}).subscribe({
      next: (response: any) => {
        console.log('Agent set to Ready:', response);
        this.snackbar.open('You are now Ready to make calls', 'Success', {
          duration: 3000
        });
      },
      error: (error) => {
        console.error('Failed to set agent ready:', error);
        this.snackbar.open('Warning: Agent status not set. You may need to login to Ozonetel portal.', 'Warning', {
          duration: 5000
        });
      }
    });
  }

  initiatecalling() {
    const callRes = this.socketService.getCallingRes();
    if (callRes) {
      const status = String(callRes.Status || '').toUpperCase();
      if (
        this.useOzonetelSdkDialer &&
        ['CONNECTED', 'CALLING', 'DISCONNECTED'].includes(status)
      ) {
        this.socketService.removeCallingRes();
        this.progressiveCallObj = {
          Status: 'Idle',
          callingType: 'ozonetel',
          isToggled: false,
          pauseCall: false,
          holdCall: false,
          transferCall: false,
        };
        return;
      }
      this.progressiveCallObj = {
        ...callRes,
        callingType:
          callRes.callingType ||
          this.progressiveCallObj.callingType ||
          toWidgetCallingType(this.activeDialerType),
      };
    }
  }

  // on progressive call action
  onCallActions(e: any) {
    if (e?.sync && e?.inputObj) {
      this.progressiveCallObj = e.inputObj;
      if (e.inputObj.Status === 'Idle') {
        this.socketService.removeCallingRes();
      } else {
        this.socketService.setCallingRes(this.progressiveCallObj);
      }
      return;
    }
    this.progressiveCallObj = {
      ...this.progressiveCallObj,
      Status: 'stopped',
      callingType:
        this.progressiveCallObj?.callingType ||
        toWidgetCallingType(this.activeDialerType),
    };
    // this.socketService.removeCallingRes();
  }

  // to init the socket connection
  initIoConnection(): void {
    this.socketService.intializeIncomeSocket();

    this.ioConnection = this.socketService
      .onMessage()
      .subscribe((message: any) => {
        this.callDefDetails = typeof message === 'string' ? JSON.parse(message) : message;

        // STEP 7 (ivrAgentConnect client): Exotel already connected the handset — open Care timeline only.
        // Do NOT setCallingRes / update progressive dialer (that path is for Cube/Ozonetel/Centro).
        // Full flow map: GET /callbacks/ivrAgentConnect in npa-server/server/routes/callbacks.js
        if (this.callDefDetails?.callingType === 'ivr') {
          if (!this.callDefDetails?.dueId) {
            return;
          }
          const callSid = String(this.callDefDetails.CallSid || '');
          const callFrom = String(this.callDefDetails.CallFrom || '');
          const openKey = callSid || `${this.callDefDetails.dueId}:${callFrom}`;
          if (!openKey || this.openedIvrCallSids.has(openKey)) {
            return;
          }
          this.openedIvrCallSids.add(openKey);
          // Query params drive STEP 8–9 (tab select + AuthInterceptor incomingCall/callingType headers).
          const queryParams: Record<string, string> = {
            callingType: 'ivr',
            CallSid: callSid,
            CallFrom: callFrom,
          };
          const timelineUrl =
            '/timeline/' + this.callDefDetails.dueId + '?' + new URLSearchParams(queryParams).toString();
          console.log('[Sidenav] Opening IVR timeline (dialer untouched)', timelineUrl);
          const windowName = 'ivr-timeline-' + openKey.replace(/[^a-zA-Z0-9_-]/g, '');
          const opened = window.open(timelineUrl, windowName);
          if (!opened) {
            console.warn('[Sidenav] IVR window.open blocked; navigating in current tab', timelineUrl);
            this.router.navigate(['/timeline', this.callDefDetails.dueId], { queryParams });
          }
          return;
        }

        if (this.callDefDetails?.callingType === 'ozonetel') {
          this.progressiveCallObj = this.ozonetelDialerFlow.toCallingState(
            this.callDefDetails,
            this.callDefDetails.Status
          );
        } else if (
          this.callDefDetails?.callingType === 'cube' ||
          this.activeDialerType === 'cube'
        ) {
          this.progressiveCallObj = this.cubeDialerFlow.toCallingState(
            this.callDefDetails,
            this.callDefDetails.Status
          );
        } else if (this.callDefDetails?.callingType === 'centro') {
          this.progressiveCallObj = this.centroDialerFlow.enrichCallDisplayData({
            ...this.callDefDetails,
            callingType: 'centro',
          });
        } else {
          this.progressiveCallObj = this.callDefDetails;
        }
        this.socketService.setCallingRes(this.progressiveCallObj);
        const isCubeCall =
          this.progressiveCallObj.callingType === 'cube' || this.activeDialerType === 'cube';
        const isCentroCall = this.progressiveCallObj.callingType === 'centro';
        if (isCubeCall && this.progressiveCallObj.Status === 'CALLING') {
          return;
        }
        if (isCentroCall && this.progressiveCallObj.Status === 'CALLING') {
          return;
        }
        localStorage.setItem('incomingCall', 'true');
        if (this.callDefDetails?.clientId) {
          localStorage.setItem('clientId', this.callDefDetails.clientId);
        }
        if (this.progressiveCallObj.Status !== 'Disconnected') {
          if (this.progressiveCallObj.callingType === 'ozonetel') {
            this.ozonetelDialerFlow.openCase(this.progressiveCallObj);
          } else if (isCubeCall) {
            if (this.progressiveCallObj.Status === 'CONNECTED' && this.progressiveCallObj.dueId) {
              this.cubeDialerFlow.openCase(this.progressiveCallObj);
            }
          } else if (isCentroCall) {
            if (this.progressiveCallObj.Status === 'CONNECTED' && this.progressiveCallObj.dueId) {
              this.centroDialerFlow.openCase(this.progressiveCallObj);
            }
          } else if (this.progressiveCallObj.dueId) {
            this.router.navigate(['/timeline/' + this.progressiveCallObj.dueId]);
          }
        }

        // if (this.progressiveCallObj.Status === "Disconnected") {
        //   setTimeout(() => {
        //     this.progressiveCallObj = { ...this.progressiveCallObj, Status: 'Idle' };
        //     this.socketService.setCallingRes(this.progressiveCallObj);
        //   }, 1000)
        // }
        // this.createNotification();
      });
    this.socketService.foceLogout().subscribe(async (res: any) => {
      res = JSON.parse(res);
      console.log('<<foceLogout>>', res.message);
      await this.logoutOzonetelSdkIfActive();
      this.userService.clearCache();
      this.userService.logout();
      this.logoutModal = false;
      this.snackbar.open(res['message'], 'Done', {
        duration: 4000,
      });
    });
    this.subscriptions.add(
      this.socketService
        .onInstructEscalate()
        .subscribe((instructOrEscalate) => {
          console.log('instructOrEscalate', instructOrEscalate);
          if (instructOrEscalate.type == 'timelineAction') {
            this.snackbar.open(instructOrEscalate.status, 'Done', {
              duration: 4000,
            });
          } else if (instructOrEscalate.type == 'actionCount') {
          } else if (instructOrEscalate.type == 'failure') {
            this.userService.notify(instructOrEscalate.status, 'error');
          } else if (instructOrEscalate.type == 'Success') {
            this.userService.notify(instructOrEscalate.status, 'Done');
          } else {
            this.instructOrEscalateObject = instructOrEscalate;
            this.createEscOrInsNotify();
          }
        })
    );
    this.subscriptions.add(
      this.socketService
        .onPaymentDateNotification()
        .subscribe((instructOrEscalate) => {
          if (instructOrEscalate.type === 'paymentDateNotification') {
            console.log(instructOrEscalate.communicationObj.offerTitle);

            // Retrieve the current array from local storage
            this.paymentNotificationsArray = JSON.parse(
              localStorage.getItem('paymentNotifications') || '[]'
            );

            // Add the new notification
            this.paymentNotificationsArray.push(
              instructOrEscalate.communicationObj
            );

            // Recalculate the count of unseen notifications
            let unseenCount = this.paymentNotificationsArray.reduce(
              (count, notification) => {
                return count + (!notification.isSeen ? 1 : 0);
              },
              0
            );

            // Update the count in each notification object
            this.paymentNotificationsArray = this.paymentNotificationsArray.map(
              (notification) => ({
                ...notification,
                count: unseenCount,
              })
            );

            // Update local storage with the updated array
            localStorage.setItem(
              'paymentNotifications',
              JSON.stringify(this.paymentNotificationsArray)
            );
            this.notifyCount = JSON.parse(
              localStorage.getItem('paymentNotifications')
            )[0].count;
          }
        })
    );

    this.subscriptions.add(
      this.socketService.updateisSeenFlag().subscribe((instructOrEscalate) => {
        if (instructOrEscalate.type === 'updateisSeenFlag') {
          console.log(instructOrEscalate.communicationObj.offerTitle);

          // Retrieve the current array from local storage
          this.paymentNotificationsArray = JSON.parse(
            localStorage.getItem('paymentNotifications') || '[]'
          );

          // Check if the notification already exists in the array
          const existingNotificationIndex =
            this.paymentNotificationsArray.findIndex(
              (notification) =>
                notification.id === instructOrEscalate.communicationObj.id
            );

          if (existingNotificationIndex !== -1) {
            // Update the isSeen flag of the existing notification
            this.paymentNotificationsArray[existingNotificationIndex].isSeen =
              true;
          } else {
            // Add the new notification if it doesn't exist
            this.paymentNotificationsArray.push(
              instructOrEscalate.communicationObj
            );
          }

          // Recalculate the count of unseen notifications
          const unseenCount = this.paymentNotificationsArray.reduce(
            (count, notification) => {
              return count + (!notification.isSeen ? 1 : 0);
            },
            0
          );

          // Update each notification object to include the unseen count
          this.paymentNotificationsArray = this.paymentNotificationsArray.map(
            (notification) => ({
              ...notification,
              count: unseenCount,
            })
          );

          // Update local storage with the updated array
          localStorage.setItem(
            'paymentNotifications',
            JSON.stringify(this.paymentNotificationsArray)
          );
          this.notifyCount = JSON.parse(
            localStorage.getItem('paymentNotifications')
          )[0].count;
        }
      })
    );

    this.subscriptions.add(
      this.socketService
        .onPositiveCustomerResponse()
        .subscribe((instructOrEscalate) => {
          if (instructOrEscalate.type === 'customerResponse') {
            console.log(instructOrEscalate.actionObj.title);
            this.paymentNotificationsArray.push(instructOrEscalate.actionObj);
            localStorage.setItem(
              'paymentNotifications',
              JSON.stringify(this.paymentNotificationsArray)
            );
          }
        })
    );

    this.subscriptions.add(
      this.socketService
        .onInstructEscalateonCron()
        .subscribe((instructOrEscalate) => {
          if (instructOrEscalate.type == 'timelineAction') {
            this.snackbar.open(instructOrEscalate.status, 'Done', {
              duration: 4000,
            });
          } else if (instructOrEscalate.type == 'actionCount') {
            let countObj = instructOrEscalate.actionObj;
            if (countObj.actionDoneCount || countObj.actionCount) {
              this.userService.notify(
                'You have completed ' +
                countObj.actionDoneCount +
                '/' +
                countObj.actionCount +
                ' cases. ',
                'Done',
                4000
              );
            }
          } else if (instructOrEscalate.type == 'failure') {
            this.userService.notify(instructOrEscalate.status, 'error');
          } else {
            this.instructOrEscalateObject = instructOrEscalate;
            this.createEscOrInsNotify();
          }
        })
    );

    this.socketService.onIncomeConnect().subscribe(() => {
      const rooms = new Set<string>();
      const addRoom = (val: any) => {
        if (val == null || val === '') return;
        const s = String(val).trim();
        if (!s) return;
        rooms.add(s);
        rooms.add(s.toLowerCase());
        const digits = s.replace(/\D/g, '');
        if (digits.length >= 10) {
          const last10 = digits.slice(-10);
          rooms.add(last10);
          rooms.add('0' + last10);
        }
      };
      addRoom(this.agentID);
      try {
        const remarks = this.userRemarks ? JSON.parse(this.userRemarks) : null;
        addRoom(remarks?.agentID);
        addRoom(remarks?.exotelAgentID);
        addRoom(remarks?.ozonetelDetails?.agentId);
      } catch (_e) {}
      addRoom(localStorage.getItem('userAgentId'));
      if (rooms.size) {
        console.log('[Sidenav] Joining socket rooms:', [...rooms]);
        rooms.forEach((room) => {
          this.socketService.onCallEmit(room).subscribe(() => {});
        });
      } else {
        console.warn('[Sidenav] No agentID found, cannot join socket room for call notifications');
      }
      const userId = this.userService.getLoggedInUserId();
      const instituteId = this.userService.getInstituteId();
      if (userId && instituteId) {
        this.socketService.uniqueUserId = String(userId) + String(instituteId);
        this.socketService.onInstructEscalateEmit(this.socketService.uniqueUserId).subscribe(() => {});
        this.socketService.paymentDateNotification(userId).subscribe(() => {});
      }
    });

    this.socketService.onCronEvent('connect').subscribe(() => {
      this.socketService
        .onCronInstructEscalateEmit(this.socketService.uniqueUserId)
        .subscribe((data) => { });
    });

    this.socketService.getcallingData().subscribe((res) => {
      // To make entries when bulk calling stoppes and Status is stopped
      const { Status } = res;

      if (Status === 'stopped') {
        this.socketService.removeCallingRes();
        this.progressiveCallObj = {
          ...this.progressiveCallObj,
          Status,
          callingType:
            this.progressiveCallObj?.callingType ||
            toWidgetCallingType(this.activeDialerType),
        };
      } else if (res?.callingType === 'ozonetel') {
        this.progressiveCallObj = this.ozonetelDialerFlow.toCallingState(res, res.Status);
        this.socketService.setCallingRes(this.progressiveCallObj);
      } else if (res?.callingType === 'cube' || this.activeDialerType === 'cube') {
        this.progressiveCallObj = this.cubeDialerFlow.toCallingState(res, res.Status);
        this.socketService.setCallingRes(this.progressiveCallObj);
      } else {
        this.progressiveCallObj = res;
        this.socketService.setCallingRes(this.progressiveCallObj);
      }
    });
    this.subscriptions.add(
      this.socketService.getCubeCallEvent().subscribe((callEvent) => {
        this.snackbar.open('Cube call envent notification', 'Success', {
          duration: 3000,
          panelClass: ['success'],
        });
        // this.router.navigate([`/timeline/${callEvent.dueId}`])
      })
    );
    this.subscriptions.add(
      this.socketService.IncomingCallSubject.subscribe({
        next: (eventData: any) => {
          this.userService.removeIncomingCall();
          this.userService.removeCallCommunicationDetailId();
          this.progressiveCallObj = {
            ...this.progressiveCallObj,
            Status: 'Completed',
            mergeCall: false,
            transferCall: false,
            conferenceCall: false,
          };
          this.socketService.setCallingRes(this.progressiveCallObj);
          const accountsRedirect = [78];
          if (accountsRedirect.includes(this.instituteID)) {
            this.router.navigate(['/accounts']);
          } else if (eventData && eventData.timerFlag) {
            this.router.navigate([this.router.url]);
            const url = this.router.url;
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([`/${url}`]).then(() => {
                  console.log(`After navigation I am on:${this.router.url}`);
                });
              });
          }
          setTimeout(() => {
            this.progressiveCallObj = {
              ...this.progressiveCallObj,
              Status: 'Idle',
            };
            this.socketService.setCallingRes(this.progressiveCallObj);
          }, 1000);
        },
        error: (err) => { },
      })
    );
    this.socketService.onEvent('disconnect').subscribe(() => {
      // this.socketService.removeCallingRes();
      // this.progressiveCallObj = { Status: 'stopped' };
    });
  }

  // to create the notification
  createNotification() {
    let options: any = { body: 'Click to know details' };
    let autoRedirection = localStorage.getItem('autoRedirection');
    this.notificationService
      .create('Incoming Call !!! ', options)
      .subscribe((data) => {
        if (data.event && data.event.type === 'click') {
          localStorage.setItem('incomingCall', 'true');
          localStorage.setItem('clientId', this.callDefDetails.clientId);
          if (this.callDefDetails && this.callDefDetails.dueId) {
            this.router.navigate(['/timeline/' + this.callDefDetails.dueId]);
          } else {
            const obj = {
              limit: 20,
              offset: 0,
              search: this.callDefDetails.defaulterId,
            };
            sessionStorage.setItem('accountsPageObj', JSON.stringify(obj));
            this.router.navigate(['/accounts']);
          }
          // Commented out code because it throws an error when marking disposition
          // when the call duration exceeds the value of this variable, this.timeValidity.

          // setTimeout(() => {
          //   localStorage.removeItem('incomingCall');
          // }, this.timeValidity);
        }
      });
  }

  // to create escalation notification
  createEscOrInsNotify() {
    let options: any = {};
    options['body'] = this.instructOrEscalateObject.communicationObj.body;
    options['sticky'] = true;
    options['tag'] = this.instructOrEscalateObject.communicationObj.DueId;
    options['renotify'] = true;
    options['requireInteraction'] = true;
    this.notificationService
      .create(this.instructOrEscalateObject.type, options)
      .subscribe((data) => {
        if (data.event && data.event.type === 'click') {
          if (
            this.instructOrEscalateObject &&
            this.instructOrEscalateObject.communicationObj
          ) {
            this.router.navigate([
              '/timeline/' +
              this.instructOrEscalateObject.communicationObj.DueId,
            ]);
          }
        }
      });
  }
  refreshSyncData() {
    this.showSyncModal = true;
    this.fetchFieldResponse();
  }
  async fetchFieldResponse() {
    this.responsesArray = [];
    await this.dexieService.getDexieFieldTable().each((response) => {
      this.responsesArray.push(response);
    });

    await this.dexieService.getPhoneLogOutbox().each((response) => {
      this.responsesArray.push(response);
    });

    this.showSyncModal = true;
    this.syncManagerButtons = [];
    const cancelButton = [
      { label: 'Cancel', class: 'nobg error', submit: false },
    ];
    const onlineButton = [
      ...cancelButton,
      { label: 'Sync now', class: 'success', disabled: false, submit: true },
    ];
    const offlineButton = [
      ...cancelButton,
      { label: 'Sync now', class: 'success', disabled: true },
    ];
    if (this.responsesArray && this.responsesArray.length > 0) {
      if (
        (this.userService.checkFieldAgentOnMobile() ||
          this.userService.checkIsTelecallerOnMobile()) &&
        navigator.onLine
      ) {
        this.syncManagerButtons = [...onlineButton];
      } else {
        this.syncManagerButtons = [...offlineButton];
      }
    } else {
      this.syncManagerButtons = [...offlineButton];
    }
  }

  async syncResponses(index: number, event$: boolean) {
    if (!event$) {
      this.showSyncModal = false;
      return;
    }
    this.loadingSteps = loadingSteps;
    if (
      this.responsesArray &&
      this.responsesArray.length > 0 &&
      index < this.responsesArray.length
    ) {
      // todo
      if (index === 0) {
        setTimeout(() => {
          this.loadingSteps[0] = {
            label: 'Data upload started',
            status: 'completed',
            icon: 'ic_said-yes',
          };
          this.loadingSteps[1].status = 'running';
          this.loadingSteps[1].icon = 'ic_refresh rotate';
        }, 3000);
      }
      this.loadingSteps[1].label = `Syncing <strong>${index + 1} of ${this.responsesArray.length
        }</strong> Please do not refresh this page`;
      let commType = this.responsesArray[index].type;
      let postData = JSON.parse(this.responsesArray[index].postData);
      let paymentObj = JSON.parse(this.responsesArray[index].paymentObj);
      this.syncingNowMsg = 'Syncing now, Please wait...';
      if (commType === 'field') {
        await this.syncFieldActions(postData, index, paymentObj);
      }
      if (commType === 'phone') {
        await this.syncPhoneActions(postData, index, paymentObj);
      }
    } else {
      this.showSyncModal = false;
      this.syncingNowMsg = null;
    }
  }

  async syncFieldActions(postData: any, index: any, paymentObj?: any) {
    this.mFieldService
      .saveCommunicationDetails(postData, this.responsesArray[index].file)
      .then((data) => {
        if (data.resultShort == 'success') {
          const { customerResponseTemplateId } = postData;
          if (this.isPayment(customerResponseTemplateId)) {
            const { communicationDetailId } = data;
            paymentObj.communicationId = communicationDetailId;
            this.createPayment(paymentObj);
          }
          this.dexieService
            .getDexieFieldTable()
            .delete(this.responsesArray[index].id);
          this.syncResponses(index + 1, true);
          this.snackbar.open(
            'Your data has been synced successfully',
            'Success',
            {
              duration: 3000,
              panelClass: ['success'],
            }
          );
        } else this.syncResponses(index + 1, true);
      })
      .catch((err) => this.syncResponses(index + 1, true));
  }
  async syncPhoneActions(postData: any, index: any, paymentObj?: any) {
    this.mPhoneService
      .saveCommunicationDetail(postData, this.responsesArray[index].file)
      .then((res) => {
        const { customerResponseTemplateId, dueId, selectedDate } = postData;
        const { resultShort, id } = res;
        if (resultShort === 'success') {
          const responseObj = {
            selectedDate,
            communicationDetailId: id,
            customerResponseTemplateId: customerResponseTemplateId,
            DueId: dueId,
          };
          this.mPhoneService
            .saveCustomerResponse(responseObj)
            .subscribe((dataObj) => {
              if (dataObj.resultShort === 'success') {
                if (this.isPayment(customerResponseTemplateId)) {
                  paymentObj.communicationId = id;
                  this.createPayment(paymentObj);
                }
              }
            });

          this.dexieService
            .getPhoneLogOutbox()
            .delete(this.responsesArray[index].id);
          this.syncResponses(index + 1, true);
          this.snackbar.open(
            'Your data has been synced successfully',
            'Success',
            {
              duration: 3000,
              panelClass: ['success'],
            }
          );
        } else this.syncResponses(index + 1, true);
      })
      .catch((err) => this.syncResponses(index + 1, true));
  }

  async createPayment(payObj: any) {
    this.mPayService.createAmountPaid(payObj).subscribe((res) => { });
  }
  // check for payment
  isPayment(templateId: any) {
    if (
      paymentArrayJson.paidArray.includes(templateId) ||
      paymentArrayJson.ptpArray.includes(templateId)
    ) {
      return true;
    }
  }

  // add class as per status
  getClassByStatus(status: string) {
    if (status === 'pending') return 'disabled';
    return 'enabled';
  }
  showProgress() {
    if (
      this.loadingSteps &&
      loadingSteps.length &&
      this.responsesArray &&
      this.responsesArray.length
    )
      return true;
  }
  openDialog() {
    const dialogRef = this.dialog.open(PaymentNotificationsComponent, {
      panelClass: 'paymentNotifications',
      data: this.paymentNotificationsArray,
    });
  }
}

function elseIf() {
  throw new Error('Function not implemented.');
}
